import React, { useState } from 'react';

import defaultDashboardIcon from '../../../assets/images/ico_custom_dashboard.svg';
import { REPORT_ICONS_URL_PREFIX } from '../constants';
import { LookerDashboard } from '../types/dashboard';

export const REPORT_ICON_STYLE: React.CSSProperties = {
  opacity: 0.54,
  width: 24,
  height: 24,
  color: 'rgba(0, 0, 0, 0.54)',
};

const buildSrc = (dashboard?: Pick<LookerDashboard, 'IconFileName'>): string =>
  dashboard?.IconFileName ? REPORT_ICONS_URL_PREFIX + dashboard.IconFileName : defaultDashboardIcon;

type ReportIconProps = {
  dashboard?: Pick<LookerDashboard, 'IconFileName'>;
};

const ReportIcon = ({ dashboard }: ReportIconProps): JSX.Element => {
  const desiredSrc = buildSrc(dashboard);
  const [hasErrored, setHasErrored] = useState(false);
  const src = hasErrored ? defaultDashboardIcon : desiredSrc;

  const handleError = () => {
    if (src !== defaultDashboardIcon) {
      setHasErrored(true);
    }
  };

  return <img style={REPORT_ICON_STYLE} src={src} alt="" onError={handleError} />;
};

export default ReportIcon;
